__turbopack_context__.v({
  "className": "roboto_3ebc152-module__-q_BSq__className",
  "variable": "roboto_3ebc152-module__-q_BSq__variable",
});
